import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { ToastController, Slides, Platform } from 'ionic-angular';

import { PlayPage } from '../play/play'; 
import { HomePage } from '../home/home';
import { ReadstoryPage } from '../readstory/readstory';

import { ViewChild } from '@angular/core';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { GamerulesModel } from '../../providers/gamerules-model';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-gamemodes',
  templateUrl: 'gamemodes.html',
  host: { '(window:resize)': 'handleResizeEvents($event)'}
})
export class GamemodesPage {
  language: string;
  settingsChanged:boolean;
  usernamePlayerChosenToStartPvpAsync:string ='';
  playerData;
  gamesdataPVPAsync: any =[];
  refreshIntervalId;
  randomPlayerData: any;
  numBooksComingSoon;

  @ViewChild('gamemodesslides') slides: Slides;

  constructor(public rubedoSideMenu: MenuController, public functions: Functions, public toastCtrl: ToastController, public platform: Platform, public translate: TranslateService, public navCtrl: NavController, public gamesrulesModel: GamerulesModel, public userdataModel:UserdataModel, public dataExchanger:DataExchanger, public playModel: GameModel) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.language = '';
    this.settingsChanged=false;
    this.numBooksComingSoon = [];
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setLanguage();
    if (this.settingsChanged) {
      this.dataExchanger.storeUserGamedataOnServer(true);
      console.log("Setting changed... saving on server");
    }
    this.settingsChanged=false;
    clearInterval(this.refreshIntervalId);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
    this.functions.getLanguage();
    this.settingsChanged=false;

    this.updateNumBooksComingSoon();
  }

  ionViewDidEnter(){
    this.functions.setScaleForBigScreen();
  }

  ngOnInit() { // at the init of the page moment
    this.platform.ready().then((readySource) => {
      this.slides.initialSlide = 0;
      this.slides.pager = true;
      this.slides.slidesPerView = 2;
      this.slides.paginationType = 'bullets';
      this.slides.loop = false; // This must be false cause there is an unresolved issue with true https://github.com/ionic-team/ionic/issues/10890
  
      if ((this.platform.width() < 550)) {
        this.slides.slidesPerView = 1;
      }
    });
  }

  handleResizeEvents(event: KeyboardEvent) {
    if ((event.target['innerWidth'] < 550)) {
      this.slides.slidesPerView = 1;
    } else {
      this.slides.slidesPerView = 2;
    }
    this.functions.setScaleForBigScreen();
  }
  /* --------- END LIFECYCLE --------- */

  changeSetting(settingType,value){
    this.settingsChanged=true;

    // Set settings in userdata is done here for in functions was not possibile due to circular reference problem
    switch (settingType) {
      case "gamemode":
        this.userdataModel.setSettingsCurrentGamemode(this.functions.gamemode);
        this.functions.setGameMode();

        this.updateNumBooksComingSoon();
        this.goToFirstSlide();
      break;

      case "language":
        this.userdataModel.setSettingsCurrentLanguage(this.functions.language);
        this.functions.setLanguage();

        this.updateNumBooksComingSoon();
        this.goToFirstSlide();
      break;

      default:
        break;
    }
  }

  /* Adds one or two greyed out books to viz if available books are lesser than two, just to fill the carousel */
  updateNumBooksComingSoon() {
    var numBooksAvailable = 0;
    for (let i = 0; i < this.functions.booksPlayable.length; i++) {
      if ((this.userdataModel.getLanguageofBook(this.functions.booksPlayable[i]) == this.functions.language)
        && (this.userdataModel.getGamemodeofBook(this.functions.booksPlayable[i]) == this.functions.gamemode)) {
        numBooksAvailable++;
      }
    }
    if (numBooksAvailable < 2) {
      if (numBooksAvailable == 0) {
        this.numBooksComingSoon = 2;
      }
      if (numBooksAvailable == 1) {
        this.numBooksComingSoon = 1;
      }
    } else {
      this.numBooksComingSoon = 0;
    }
  }

  goToPlay(chosenBook) {
    if (!this.userdataModel.isBookComplete(chosenBook)) {
      this.functions.setIdCurrentBook(chosenBook);
      //let currentIndex = this.slides.getActiveIndex();    
      this.navCtrl.push(PlayPage, {});
    }
  }

  goToReadStory(chosenBook) {
    this.functions.setIdCurrentBook(chosenBook);
    this.navCtrl.push(ReadstoryPage, {});
  }

  prevSlide() {
    this.slides.slidePrev();
  }

  nextSlide() {
    this.slides.slideNext();
  }

  goToFirstSlide() {
    this.slides.slideTo(0);
  }
}



// WEBPACK FOOTER //
// ./src/pages/gamemodes/gamemodes.ts